/**
 * Created by vladislav on 4/8/2024
 */

const Info = {
    nativePlatforms: ["microsoft", "gpg", "mygames", "macos", "wechat", "msix", "g5windows"],
    nativeMobilePlatforms: ["android", "amazon", "ios", "digital", "rustore", "onestore", "epicgames"],

    bus: new ConnectorEventEmitter(),

    initialize: function () {
        connector.info.source = this._detectSource();
        connector.info.isMobile = this._detectMobile();
        connector.info.isNative = this._detectNative();
    },

    _detectLanguage: function () {
        let language = window.navigator.language || window.navigator.browserLanguage;
        if (language) {
            language = language.split("-")[0];

            if (language === "du") {
                return connector.LANGUAGE_DUTCH;
            }

            return language;
        }

        return connector.LANGUAGE_ENGLISH;
    },

    _detectMobile: function () {
        if (Info.nativeMobilePlatforms.includes(connector.info.source)) {
            return true;
        }

        const ua = window.navigator.userAgent.toLowerCase();

        return /mobile|android|iphone|ipad/.test(ua);
    },

    _detectNative: function () {
        return Info.nativePlatforms.includes(connector.info.source) || Info.nativeMobilePlatforms.includes(connector.info.source);
    },

    _detectOS: function () {
        const nav = window.navigator;
        const ua = nav.userAgent.toLowerCase();

        if (/android/i.test(ua) || /android/i.test(nav.platform)) {
            return connector.OS_ANDROID;
        }
        if (/(iPad|iPhone|iPod)/i.test(ua) || /(iPhone|iPad|iPod)/i.test(nav.platform)) {
            return connector.OS_IOS;
        }

        let osName = connector.OS_UNKNOWN;
        if (nav.appVersion.indexOf("Win") !== -1 || nav.platform.startsWith("Win")) {
            osName = connector.OS_WINDOWS;
        } else if (nav.platform.startsWith("Mac")) {
            osName = connector.OS_OSX;
        } else if (nav.appVersion.indexOf("Mac") !== -1) {
            osName = connector.OS_OSX;
        } else if (nav.appVersion.indexOf("X11") !== -1 && nav.appVersion.indexOf("Linux") === -1) {
            osName = connector.OS_UNIX;
        } else if (nav.appVersion.indexOf("Linux") !== -1) {
            osName = connector.OS_LINUX;
        }

        return osName;
    },

    _isBot: function () {
        return /bot|crawler|spider|headless|lighthouse|phantomjs|facebookexternalhit/i.test(window.navigator.userAgent || "");
    },

    _detectSource: function () {
        // only when the test platform is in the build: a bundle without @web (samsung, instant, ...) has no
        // TestPlatform, a headless store checker would crash on them
        if (Info._isBot() && typeof TestPlatform !== "undefined") {
            return "test";
        }

        const existParameterByName = function (name) {
            let parentHref;
            try {
                parentHref = window.parent.location.href;
            } catch (err) {
                parentHref = "";
            }
            return window.location.href.indexOf(name) !== -1 || parentHref.indexOf(name) !== -1;
        };

        if (connector.config.source === "msstart" && !existParameterByName("msstart_sdk_init")) {
            return "pwa";
        }

        if (connector.config.debugMode && connector.config.source === "plinga") {
            return "plng";
        }

        if (connector.config.source) {
            return connector.config.source;
        }

        if (window.location.href.includes("apps.fbsbx.com")) {
            return "instant";
        }

        if (window.location.href.includes("coolmathgames.com")) {
            return "coolmath";
        }

        const searchParams = new URLSearchParams(window.location.search);

        const vkPlatform = searchParams.get("vk_platform");
        if (vkPlatform) {
            return vkPlatform.endsWith("_ok") ? "ok" : "vk";
        }

        const paramsSource = searchParams.get("source");
        if (["android", "amazon", "ios", "macos", "plng", "digital", "rustore", "gdcom", "mygames",
            "kongregate", "msstart", "microsoft", "crazy", "xiaomi", "cleverapps", "labsystech", "samsung",
            "youtube", "gamesnack", "telegram", "vk", "ok", "mspwa", "onestore", "epicgames", "reddit", "g5windows", "msix", "arkadium", "addicting", "pogo"].includes(paramsSource)) {
            return paramsSource;
        }

        if (existParameterByName("msstart_sdk_init")) {
            return "msstart";
        }

        if (existParameterByName("dr_auth_code")) {
            return "draugiem";
        }

        if (existParameterByName("logged_user_id")) {
            return "ok";
        }

        const yandexAppId = connector.config.yandex && connector.config.yandex.appId;
        if (existParameterByName("yandex") || existParameterByName("playhop.com")
            || yandexAppId && existParameterByName(`app-id=${yandexAppId}`)) {
            return "yandex";
        }

        if (existParameterByName("fotostrana.ru")) {
            return "fotostrana";
        }

        if (existParameterByName("source=spmobage")) {
            return "sp_mbga";
        }

        if (existParameterByName("mbga-platform.jp")) {
            return "mbga";
        }

        if (existParameterByName("source=xsolla")) {
            return "cleverapps";
        }

        if (connector.config.mm && existParameterByName(`app_id=${connector.config.mm.appId}`)) {
            return "mm";
        }

        if (connector.config.testPlatform) {
            return "test";
        }

        if (existParameterByName("index-ru")) {
            return "labsystech";
        }

        return "cleverapps";
    }
};